import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const projects = [
  {
    name: "Kootenay Home Pros",
    tag: "Home services directory",
    url: "https://kootenayhomepros.ca",
    img: "https://images.pexels.com/photos/36447570/pexels-photo-36447570.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
    desc: "“Find trusted home contractors across the Kootenays.” A local directory connecting people with plumbers, electricians, roofers, landscapers and more.",
  },
  {
    name: "Fetch Pups",
    tag: "Dog walking & training",
    url: "https://fetchpups.ca",
    img: "https://static.wixstatic.com/media/7cc6fc_6b5773c349af4f7ab3c0b4aace77497e~mv2.png/v1/fill/w_800,h_600,al_c,q_90,enc_auto/7cc6fc_6b5773c349af4f7ab3c0b4aace77497e~mv2.png",
    imgPosition: "50% 32%",
    desc: "“Bringing you and your pup closer together with trust, love and obedience.” A friendly site for a dog walking & behaviour-training business.",
  },
  {
    name: "Spotless Cleanrz",
    tag: "Cleaning services",
    url: "https://spotlesscleanrz.com",
    img: "https://static.wixstatic.com/media/7cc6fc_037d4b4d1cac4c34901cbab61708aab6~mv2.png/v1/fill/w_600,h_600,al_c,q_90,enc_auto/7cc6fc_037d4b4d1cac4c34901cbab61708aab6~mv2.png",
    imgPosition: "50% 38%",
    desc: "“Where you don't have to clean after your cleaner.” Residential, commercial, AirBnB and deep-cleaning services — online and ready to book.",
  },
];

export default function Work() {
  return (
    <section id="work" className="bg-[#0B281B] py-24 text-white sm:py-32">
      <div className="mx-auto max-w-6xl px-6 sm:px-12">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#98D8BA]">
              Our work
            </span>
            <h2 className="mt-4 font-heading text-4xl font-medium tracking-tight sm:text-5xl">
              Small businesses, big results.
            </h2>
          </div>
          <a
            href="#contact"
            data-testid="work-cta"
            className="inline-flex items-center gap-2 rounded-full border border-white/30 px-6 py-3 text-sm font-medium transition-colors hover:bg-white hover:text-[#0B281B]"
          >
            Start your project <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {projects.map((p, i) => {
            const CardTag = p.url ? "a" : "div";
            const cardProps = p.url
              ? { href: p.url, target: "_blank", rel: "noopener noreferrer" }
              : {};
            return (
              <motion.div
                key={p.name}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`work-card-${i}`}
                className="group overflow-hidden rounded-3xl bg-white/5 border border-white/10"
              >
                <CardTag
                  {...cardProps}
                  className="block"
                  data-testid={p.url ? `work-link-${i}` : undefined}
                >
                  <div className="aspect-[4/3] overflow-hidden bg-white">
                    <img
                      src={p.img}
                      alt={p.name}
                      style={p.imgPosition ? { objectPosition: p.imgPosition } : undefined}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-6">
                    <span className="text-xs font-bold uppercase tracking-widest text-[#98D8BA]">
                      {p.tag}
                    </span>
                    <h3 className="mt-2 font-heading text-xl font-medium">{p.name}</h3>
                    <p className="mt-2 text-sm text-white/70">{p.desc}</p>
                    {p.url && (
                      <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-[#98D8BA] transition-colors group-hover:text-white">
                        Visit live site <ArrowUpRight className="h-4 w-4" />
                      </span>
                    )}
                  </div>
                </CardTag>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
